import React from 'react';
export function TargetAudience() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-70">
      <div className="max-w-5xl mx-auto" data-id="element-71">
        <div className="bg-gradient-to-r from-jazugas-blue to-jazugas-blue/80 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-72">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-73">
            ¿Para quién es?
          </h2>
          <p className="text-xl md:text-2xl text-white/95 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-74">
            Ideal para:{' '}
            <span className="font-semibold text-jazugas-gold" data-id="element-75">
              sodas, restaurantes, panaderías, supermercados
            </span>{' '}
            y negocios que utilizan o manejan cilindros de Gas LP.
          </p>
        </div>
      </div>
    </section>;
}